
export const convertSizeValueToString = (size = null) => {
    if(!size) {
        return null;
    }

    const KB = Math.pow(2, 10);
    const MB = Math.pow(2, 20);

    const combineString = (result, unit) => {
        return `${ result.toFixed(1) } ${ unit }`;
    };

    switch(true) {
        case +size / KB < 1000:
            return combineString(+size / KB, 'KB');
        default:
            return combineString(+size / MB, 'MB');
    }
};